import styled from "@emotion/styled";

const SimpleCard = styled.div`
  border-radius: 10px;
  background-color: white;
  padding: 25px;
`;

export default SimpleCard;
